import { InteractionStatus } from '@azure/msal-browser';
import { useMsal, useAccount } from '@azure/msal-react';
import { getAccessToken } from 'common/helpers';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from 'store';
import { getMaintenanceMessage } from './MaintenanceMessage.actions';
import { maintenanceMessageSelector } from './MaintenanceMessage.selectors';
import styles from './MaintenanceMessage.module.scss';

const MaintenanceMessage: React.FC = () => {
  const dispatch = useDispatch();
  const { maintenanceMessage } = useSelector((state: AppState) => ({
    maintenanceMessage: maintenanceMessageSelector(state),
  }));
  const { instance, accounts, inProgress } = useMsal();
  const account = useAccount(accounts[0] || {});

  useEffect(() => {
    if (account && inProgress === InteractionStatus.None) {
      getAccessToken(instance, account, inProgress).then((response) => {
        if (response?.accessToken)
          dispatch(getMaintenanceMessage(response.accessToken));
      });
    }
  }, [dispatch, instance, account, inProgress]);

  const result = maintenanceMessage?.message && (
    <b className={styles.maintenanceText}>{maintenanceMessage.message}</b>
  );

  return result || <></>;
};

export default MaintenanceMessage;
